import type { IconsList } from 'types/cms/blocks';

import { IconsListLarge } from './IconsListLarge';
import { IconsListSmall } from './IconsListSmall';

interface ProductIconsListProps {
  icons: IconsList['icons'];
  variant?: IconsList['variant'];
}

export function ProductIconsList({
  icons,
  variant = 'lg',
}: ProductIconsListProps) {
  if (variant === 'lg') return <IconsListLarge icons={icons} />;
  if (variant === 'sm') return <IconsListSmall icons={icons} />;

  return null;
}
